import React, { useEffect, useState } from 'react'
import CustomDateTime from 'designer/component/element/DateTime'
import { getDateTimeFormValue } from 'designer/component/action/Date'

const DateTimeControl = (props) => {
  const { uischema, handleChange, path, config } = props
  const data = config?.jsonData
  const { defaultType } = uischema
  const [initial, setInitial] = useState(null)

  const updateData = (dateTime) => {
    let value = getDateTimeFormValue(dateTime, uischema?.timestamp)
    updateValue(value)
  }

  const updateValue = async (value) => {
    handleChange(path, value)
  }

  useEffect(() => {
    if (initial) return
    if (!data && defaultType === 'current') {
      let currentDate = getDateTimeFormValue(new Date(), uischema?.timestamp)
      updateValue(currentDate)
      setInitial(true)
    }
  }, [data, defaultType, uischema?.timestamp])

  return (
    <CustomDateTime
      {...props}
      uischema={uischema}
      value={data}
      updateData={updateData}
      uiKey={uischema.key}
    />
  )
}

export default DateTimeControl
